module.exports = __webpack_public_path__ + "static/media/firefox.7cb5390b.png";